import React from 'react';

import { MapOutlined } from '@mui/icons-material';
import { FlexTable, FlexTableColumn, NoItemsLoadingBody } from '@uplift/ui-v2';

import { StateNameCell } from './StateNameCell.component';
import { StateStatusCell } from './StateStatusCell.component';
import { PracticeStateRow } from './PracticeStatesTable.types';

export type PracticeStatesTableProps = {
  rows: PracticeStateRow[];
  loading: boolean;
};

export const PracticeStatesTable: React.FC<PracticeStatesTableProps> = (props) => {
  const columns = React.useMemo(() => [
    {
      field: 'stateName',
      headerName: 'State',
      flex: 1,
      sortable: true,
      renderCell: StateNameCell,
    } as FlexTableColumn<PracticeStateRow, 'stateName'>,
    {
      field: 'status',
      headerName: ' ',
      renderCell: StateStatusCell,
      align: 'right',
      sortable: false,
    } as FlexTableColumn<PracticeStateRow, 'status'>,
  ], []);

  if (props.loading) {
    return <NoItemsLoadingBody />;
  }

  return (
    <FlexTable
      columns={columns}
      rows={props.rows}
      pinColumn={[ 'start', 'end' ]}
      infiniteScroll={{ perPage: 25 }}
      emptyOverlayProps={{
        icon: <MapOutlined fontSize="inherit" />,
        message: 'No Practice States',
      }}
      initialSort={{
        colId: 'stateName',
        type: 'asc',
      }}
    />
  );
};
